import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { SALE_ANNOUNCEMENT_DISMISSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SALE_ANNOUNCEMENT_DISMISSED";
import React, { useEffect } from "react";
import styled, { css } from "styled-components";
import { NavigationLink } from "@faire/retailer/components/Header/desktop/NavigationLinksBar/__internal__/NavigationLink";
import { useShouldShowSaleAnnouncementNudge } from "@faire/retailer/components/Header/desktop/SaleAnnouncementNudge/useShouldShowSaleAnnouncementNudge";
import { SERRANO } from "@faire/retailer-visitor-shared/consts/colors";
import { trackRetailerEvent } from "@faire/retailer/lib/trackRetailerEvent";
import { useCategoryNavigationPrefetch } from "@faire/retailer/lib/useCategoryNavigationPrefetch";
import { useSettingUpdateSaleColorCopy, useAssignSettingUpdateSaleColorCopy } from "@faire/retailer/settings/useSettingUpdateSaleColorCopy";
import { useMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
export var L1Link = function(param) {
    var link = param.link, selectedLinkName = param.selectedLinkName, onClick = param.onClick, onMouseEnter = param.onMouseEnter, className = param.className, tooltip = param.tooltip;
    var _useMilestone = useMilestone(SALE_ANNOUNCEMENT_DISMISSED), dismissSaleAnnouncement = _useMilestone.setHasOccurred;
    var shouldShowSaleTooltip = useShouldShowSaleAnnouncementNudge();
    var handleClick = React.useCallback(function() {
        onClick(link);
        trackRetailerEvent("/header-categories/".concat(link.name));
    }, [
        link,
        onClick
    ]);
    var isSalesLink = link.categoryPathIdentifier === "sale" || link.isWarehouseSale;
    var assignUpdateSaleColorCopy = useAssignSettingUpdateSaleColorCopy();
    var isUpdateSaleColorCopy = useSettingUpdateSaleColorCopy();
    var _useCategoryNavigationPrefetch = useCategoryNavigationPrefetch(), prefetchOnMouseEnter = _useCategoryNavigationPrefetch.prefetchOnMouseEnter, prefetchOnTouchStart = _useCategoryNavigationPrefetch.prefetchOnTouchStart, clearPrefetchTimeoutOnBlur = _useCategoryNavigationPrefetch.clearPrefetchTimeoutOnBlur;
    useEffect(function() {
        if (isSalesLink) {
            assignUpdateSaleColorCopy();
        }
    }, [
        assignUpdateSaleColorCopy,
        isSalesLink
    ]);
    var handleMouseEnter = React.useCallback(function() {
        onMouseEnter(link);
        prefetchOnMouseEnter(link.to);
        if (shouldShowSaleTooltip) {
            dismissSaleAnnouncement();
        }
    }, [
        dismissSaleAnnouncement,
        link,
        onMouseEnter,
        shouldShowSaleTooltip,
        prefetchOnMouseEnter
    ]);
    var linkColorOverride = selectedLinkName ? Core.text.subdued : undefined;
    var salesLinkColor = isUpdateSaleColorCopy ? SERRANO : Decorative.shade.orange;
    var _link_categoryPathIdentifier;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        "aria-haspopup": "menu",
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter,
        $isSelected: link.name === selectedLinkName,
        className: className,
        $linkColorOverride: isSalesLink ? salesLinkColor : linkColorOverride,
        $hasLink: !!link.to,
        onTouchStart: function() {
            return prefetchOnTouchStart(link.to);
        },
        onMouseLeave: clearPrefetchTimeoutOnBlur,
        children: [
            /*#__PURE__*/ _jsx(StyledLink, {
                link: link,
                onClick: handleClick,
                dataTestId: "header-".concat((_link_categoryPathIdentifier = link.categoryPathIdentifier) !== null && _link_categoryPathIdentifier !== void 0 ? _link_categoryPathIdentifier : "category", "-dropdown-link"),
                children: link === null || link === void 0 ? void 0 : link.name
            }),
            tooltip
        ]
    });
};
var StyledLink = styled(NavigationLink).withConfig({
    componentId: "sc-6f55b070-0"
})([
    "",
    ";border-bottom:1px solid transparent;white-space:nowrap;&:active,&:focus{color:",
    ";}"
], TypographyStyles({
    as: undefined
}), Core.text.subdued);
var Wrapper = styled.div.withConfig({
    componentId: "sc-6f55b070-1"
})([
    "display:flex;cursor:",
    ";",
    ";",
    ";"
], function(props) {
    return props.$hasLink ? "pointer" : "default";
}, function(props) {
    return props.$linkColorOverride ? css([
        "",
        "{color:",
        ";}"
    ], StyledLink, props.$linkColorOverride) : "";
}, function(props) {
    return props.$isSelected ? css([
        "",
        "{color:",
        ";border-bottom-color:",
        ";}"
    ], StyledLink, Core.text.default, Core.text.default) : "";
});
